import axios from "axios";
import {BASE_PATH} from "../services/api";

export const getStores = async () => {
    return axios.get(BASE_PATH + "/admin/get-stores", {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
};

export const updateStoreActivity = async (formData) => {
    return axios.post(BASE_PATH + "/admin/update-store-activity", formData, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
        },
    })
}
